@if (servicingFacilityDetails && premierHealthIncData && locationData) {
  <div class="">
    <p-table
      responsiveLayout="scroll"
      class="col"
      [value]="servicingFacilityDetails"
      [columns]="servicingFacilityCols"
      data-test-id="facility-table"
      >
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col) {
            <th [ngStyle]="col.styles">
              {{ col.header }}
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <td>
            <div class="p-text-break-word">
              {{ data.companyName }}
            </div>
          </td>
          <td>
            <div class="p-text-break-word">
              {{ data.npi }}
            </div>
          </td>
          <td>
            <div class="p-text-break-word">
              {{ data.network }}
            </div>
          </td>
          <td [class.attention-mark]="data.outOfNetwork">
            <div class="flex items-center justify-center p-field-checkbox-container">
              <p-checkbox
                data-test-id="out-of-network-checkbox"
                [ngModel]="data.outOfNetwork"
                [binary]="true"
                [disabled]="true"
              ></p-checkbox>
            </div>
          </td>
          @if (isGoldCardVisible) {
            <td [class.attention-mark]="data.isGoldCardProvider">
              <div class="flex items-center justify-center p-field-checkbox-container">
                <p-checkbox
                  data-test-id="gold-card-provider-checkbox"
                  [ngModel]="data.isGoldCardProvider"
                  [binary]="true"
                  [disabled]="true"
                ></p-checkbox>
              </div>
            </td>
          }
          @if (isGoldCardVisible && data.isGoldCardProvider) {
            <td>
              <div class="p-text-break-word">
                {{ data.goldCardAuthorizationType | emptyPlaceholder }}
              </div>
            </td>
          }
          <td>
            <div class="p-text-break-word">
              {{ data.taxId | emptyPlaceholder }}
            </div>
          </td>
          <td>
            <div class="p-text-break-word">
              {{ data.cms | emptyPlaceholder }}
            </div>
          </td>
          <td>
            <div class="p-text-break-word">
              {{ data.medicaid | emptyPlaceholder }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-panel header="Facility Contact Information" class="col">
      <div class="">
        <span class="col font-semibold">
          {{ providerAccountDTO.providerName }}
        </span>
        <p-table
          [columns]="premierHealthCols"
          [value]="premierHealthIncData"
          responsiveLayout="scroll"
          class="col"
          data-test-id="contact-info-table"
          >
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [ngStyle]="col.styles">
                  {{ col.header }}
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col) {
                <td>
                  <div class="p-text-break-word">
                    {{ rowData[col.field] }}
                  </div>
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
        <span class="col font-semibold">Location Information</span>
        <div class="col grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data p-form-aligned">
          <div class="col-span-12">
            <div class="field">
              <label data-test-id="location-phone-label">Phone: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ locationData.phone | phoneNumber }}
                </div>
              </div>
            </div>
            <div class="field">
              <label data-test-id="location-fax-label">Fax: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ locationData.fax | phoneNumber }}
                </div>
              </div>
            </div>
            <div class="field">
              <label data-test-id="location-fax-confirmed-label">Fax Confirmed? </label>
              <div class="p-field-value flex items-center">
                <div class="readonly-field">
                  <p-checkbox
                    data-test-id="location-fax-confirmed-checkbox"
                    [ngModel]="locationData.faxConfirmed"
                    [binary]="true"
                    [disabled]="true"
                  ></p-checkbox>
                </div>
              </div>
            </div>
            <div class="field">
              <label data-test-id="fax-confirmed-date-label">Fax Confirmed Date: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ locationData.faxConfirmedDate | date: 'MM/dd/yyyy' | emptyPlaceholder }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </div>
}
